module.exports = __webpack_public_path__ + "65f802ffe8d16c15f02e50e02f093c90.pdf";